
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { keys, orderBy, toArray } from "lodash";
import TeamListTable from "./TeamListTable.vue";
import { LeaderBoardTeams } from "../../models/LeaderBoardTeams";
import { Duration } from "luxon";
import { LeaderBoard } from "@/models/LeaderBoard";
import DateHelper from "@/utils/DateHelper";
import { Game } from "@/models/Game";

@Component({
  components: {
    TeamListTable,
  },
})
class LeaderboardTable extends Vue {
  @Prop({ default: "" }) readonly selectedValue!: string;
  @Prop({ default: "None Selected" }) readonly leaderBoardTitle!: string;
  searchFilter = "";
  busy = false;
  show = false;
  content = {};
  readonly leaderBoardData!: LeaderBoardTeams;
  private leaderBoardArray: LeaderBoardTeams[] = [];

  get showDeleteButton(): boolean {
    if (this.getGame !== undefined) {
      const status = DateHelper.getStatus(this.getGame, this.getPreAppLaunch);
      if (
        status === "LIVE" ||
        status === "TEMPLATE" ||
        status === "OPEN" ||
        status === "ENDED"
      ) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  }

  get getPreAppLaunch(): number {
    return this.$store.state.authenication.appPrelaunch._value;
  }

  get getGame(): Game {
    return this.$store.state.gameStore.games.find(
      (x: Game) => x.key == this.selectedValue
    );
  }

  get teamsCount(): number {
    return this.leaderBoardArray.length;
  }

  get teamsWin(): number {
    return this.leaderBoardArray.filter((stats) => {
      return stats.game_status === "win";
    }).length;
  }

  /**
   * @summary - Gather together status counts to determine how many forefeited the game
   */
  get teamsFail(): number {
    return this.leaderBoardArray.filter((stats) => {
      return stats.game_status === "fail";
    }).length;
  }

  /**
   * @summary - Gather together status counts to determine how many are active/incomplete
   */

  get teamsActive(): number {
    return this.leaderBoardArray.filter((stats) => {
      return stats.game_status === "active";
    }).length;
  }

  /**
   * @summary - Gather together status counts to determine how many abandoned the game
   */
  get teamsExpired(): number {
    return this.leaderBoardArray.filter((stats) => {
      return stats.game_status === "expired";
    }).length;
  }

  get totalNumberOfPlayers(): number {
    let total = 0;
    for (const k in this.leaderBoardArray) {
      total += Object.keys(this.leaderBoardArray[k].members).length;
    }
    return total;
  }

  get getAveragePlayersPerGame(): number {
    return Number((this.totalNumberOfPlayers / this.teamsCount).toFixed(2));
  }

  get teamSuccessPercentage(): number {
    const wins = this.leaderBoardArray.filter((stats) => {
      return stats.game_status === "win";
    }).length;

    const successPer = Number(
      ((wins / this.leaderBoardArray.length) * 100).toFixed(2)
    );
    //const successPer = Number(((this.teamStatsList.length / 100) * wins).toFixed(2));
    return successPer;
  }

  @Watch("selectedValue")
  async onPropertyChanged(value: string): Promise<void> {
    this.leaderBoardArray = [];
    if (value !== "") {
      this.busy = true;
      const result = await this.$store.dispatch(
        "leaderBoardStore/getAllLeaderBoardForGameTeams",
        value
      );
      for (const [key, value] of Object.entries(result)) {
        Object.assign(result[key], { teamId: key });
      }
      this.leaderBoardArray = orderBy(
        result,
        ["game_status", "timer.comp_dur_s"],
        ["desc", "asc"]
      );
      this.busy = false;
    }
  }
  @Watch("leaderBoardData")
  async onLeaderBoardDataChange(value: LeaderBoard): Promise<void> {
    if (value !== null) {
      this.leaderBoardArray = orderBy(
        toArray(value.team_stats),
        ["game_status", "timer.comp_dur_s"],
        ["desc", "asc"]
      );
    }
  }

  onRowSelected(rows: any): void {
    if (rows.length < 1) return;
    this.content = rows[0];
    this.show = true;
    this.$bvModal.show("team-modal");
  }

  get leaderBoardTitleValue(): string {
    if (this.leaderBoardTitle == "") {
      return "None selected";
    } else {
      return this.leaderBoardTitle;
    }
  }
  get totalRows(): number {
    return this.leaderBoardArray.length;
  }
  closeTeamLeaderList(): void {
    this.show = false;
  }
  perPage = 100;
  currentPage = 1;
  fields = [
    {
      key: "game_status",
      label: "Status",
      sortable: true,
    },
    {
      key: "team_dname",
      label: "Team Name",
      sortable: true,
    },
    {
      key: "members",
      label: "#Members",
      sortable: false,
      formatter: (value: unknown) => {
        // * Get a count of how manay members in the team
        return keys(value).length;
      },
    },
    {
      key: "timer",
      label: "Completed (h:m:s)",
      sortable: true,
      formatter: (value: any) => {
        if (!value) {
          return "active";
        }
        const compDurS = value.comp_dur_s;
        return compDurS != null
          ? Duration.fromObject({ seconds: compDurS }).toFormat("hh:mm:ss")
          : "active";
      },
    },
    {
      key: "verified",
      sortable: true,
    },
  ];
}
export default LeaderboardTable;
